export default {
  // Sao lưu
  Backup: 1,

  // Phục hồi
  Restore: 2,

  // Xóa
  Delete: 3,

  // Thêm mới
  Add: 4,
  // Thêm dữ liệu từ năm trước
  AddFromPreviousYear: 5,
  //  Đổi tên
  Rename: 6,

  // Lưu trữ
  Store: 7,

  // Xóa dữ liệu lưu trữ
  DeleteStore: 8,

  // Cập nhật TT 24/2024/TT-BTC
  ConversionOfAccountingSystem: 9,
};
